<div class="flex h-full flex-col overflow-hidden">
  @if (params.subtitle) {
    <div class="shrink-0 pb-2 text-sm text-gray-600">{{ params.subtitle }}</div>
  }
  <div class="min-h-0 flex-1 overflow-hidden">
    <ag-grid-angular class="qb-ag-grid-list w-full h-full" [ngClass]="userPrefsService.gridTheme"
      [rowData]="params.rowData" [columnDefs]="params.columnDefs" [defaultColDef]="defaultColDef"
      [rowHeight]="gridConfig.ROW_HEIGHT" [headerHeight]="gridConfig.HEADER_HEIGHT" [floatingFiltersHeight]="35"
      [pagination]="true" [paginationPageSize]="100" [paginationPageSizeSelector]="[10, 20, 50, 100]"
      [sideBar]="sideBar" [enableRangeSelection]="true" [rowGroupPanelShow]="'always'" [pivotPanelShow]="'always'"
      [groupDefaultExpanded]="params.groupDefaultExpanded ?? 0" animateRows (gridReady)="onGridReady($event)" />
  </div>
  <div class="flex shrink-0 justify-start gap-2 pt-3">
    <button pButton icon="pi pi-download" label="Export to Excel" class="p-button-outlined p-button-sm"
      (click)="onExport()"></button>
    <button pButton label="Close" class="p-button-sm" (click)="onClose()"></button>
  </div>
</div>
